export function matchUrl(urls: string[], currentPath: string): boolean {
    let isMatch = urls.indexOf(currentPath) > -1;
    if (!isMatch) {
        let wildcards = urls.filter((url) => {
            return url.indexOf("*") > -1;
        });
        for (let i = 0; i < wildcards.length; i++) {
            let wildcard = wildcards[i];
            let regex = new RegExp(wildcard.replace("*", ".*"));
            if (regex.test(currentPath)) {
                isMatch = true;
                break;
            }
        }
    }
    return isMatch;
}
